module.exports = __webpack_public_path__ + "static/media/react.f0b97fb24d0e5835a462da1b331f7374.svg";